// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d2699f51","498":"a52224cb","513":"058217a1"}[chunkId] + ".chunk.js";
};